export enum IPageStatus {
    EARLY = 'EARLY', // 预热
    REGULAR = 'REGULAR', // 开售
}
